import React from "react";

const Battery = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill" fill={fill} d="M4.667 11.667h19.555V24.11H4.667V11.667Z" />
        <path className="u_fill"
            d="M32.545 14.926v-2.963c0-1.636-1.302-2.963-2.909-2.963H4.91C3.302 9 2 10.326 2 11.963v11.852c0 1.636 1.302 2.963 2.91 2.963h24.726c1.607 0 2.91-1.327 2.91-2.963v-2.963c.803 0 1.454-.663 1.454-1.482v-2.963c0-.818-.651-1.481-1.455-1.481Zm-1.454 1.481v7.408c0 .818-.651 1.481-1.455 1.481H4.91c-.803 0-1.454-.663-1.454-1.481V11.963c0-.818.65-1.482 1.454-1.482h24.727c.804 0 1.455.664 1.455 1.482v4.444Z"
            fill={fill}
        />
    </svg>
);

export default Battery;